// extracted by mini-css-extract-plugin
export var formMobile = "block-cost-module--formMobile--8l0fk";
export var formDesktop = "block-cost-module--formDesktop--3QF9W";
export var marginBottom = "block-cost-module--marginBottom--2iZEg";